import { Chip, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import type { SortByDataType, SortOrderType } from "./types";

type TopicListHeaderProps = {
	selectedSortByItem?: SortByDataType;
	selectedSortOrder: SortOrderType;
	title: string;
	onSortPress: () => void;
	numTags: number;
};

const TopicListHeader = ({
	selectedSortByItem,
	selectedSortOrder,
	title,
	onSortPress,
	numTags,
}: TopicListHeaderProps) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();
	const showSort = numTags > 5;
	return (
		<Box
			padding={16}
			flexDirection="row"
			alignItems="center"
			justifyContent="space-between"
			borderBottomWidth={1}
			borderBottomColor={theme.palette.divider}
		>
			<Text
				style={{
					color: theme.colors.onSurfaceVariant,
				}}
				variant="labelLarge"
			>
				{title}
			</Text>
			{showSort && (
				<Box flexDirection="row" alignItems="center" gap={8}>
					<Chip
						compact
						mode="outlined"
						icon={selectedSortByItem?.icon}
						onPress={onSortPress}
						closeIcon={
							selectedSortOrder === "asc" ? "sort-ascending" : "sort-descending"
						}
						onClose={onSortPress}
						style={{
							backgroundColor: isMobile
								? "transparent"
								: theme.colors.elevation.level1,
						}}
					>
						{selectedSortByItem?.label}
					</Chip>
				</Box>
			)}
		</Box>
	);
};

export default TopicListHeader;
